module.exports = __webpack_public_path__ + "img/r3_921_live.6cbf0b62.jpg";